export const webClientId = "48464566007-nns2u42o90rrl1ng6re7b7mak0mcdjeb.apps.googleusercontent.com";
